// extracted by mini-css-extract-plugin
export default {"AdminNavbar":"adminNavbar_AdminNavbar__4GRRq","active":"adminNavbar_active__WRrOQ","triangle":"adminNavbar_triangle__M+umW"};